import clsx from "clsx";
import { useId } from "react";
import { useTranslation } from "react-i18next";

type PillProps = {
  text: string | React.ReactNode;
  className?: string;
};

export const Pill = ({ text, className }: PillProps) => {
  return (
    <div
      className={clsx(
        "h-[26px] py-[2px] px-[10px] max-w-fit bg-cerulean-blue-100 rounded-full text-center text-noble-blue-500 font-semibold",
        className
      )}
      style={{ fontSize: "12px", lineHeight: "22px" }}
    >
      {text}
    </div>
  );
};

const FreeTrialIcon = () => {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20" fill={`url(#${gradientId})`} rx="10"></rect>
      <path
        fill="#FEFEFE"
        d="M13.154 5.724c-1.669 0-3.906 1.144-5.408 3.11H6.5c-.9 0-1.416.673-1.771 1.383l-.477.951H6.5l1.166 1.167L8.833 13.5v2.247l.951-.476c.71-.354 1.382-.87 1.382-1.77v-1.247c1.967-1.502 3.111-3.74 3.111-5.407V5.724zm-1.988 2.333a.778.778 0 1 1 0 1.556.778.778 0 0 1 0-1.556m-5.055 4.667-.39.389c-.56.561-.777 1.944-.777 1.944s1.32-.154 1.945-.778l.389-.389z"
      ></path>
      <defs>
        <linearGradient
          id={gradientId}
          x1="1.291"
          x2="23.927"
          y1="28.011"
          y2="24.362"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.302" stopColor="#0648FF"></stop>
          <stop offset="1" stopColor="#00B2FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export const FreeTrialPill = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "previewLayout"
  });
  return (
    <Pill
      text={
        <div className="flex items-center gap-x-1">
          <FreeTrialIcon />
          {t("header.freeTrial")}
        </div>
      }
    />
  );
};
